import { cn } from "@/lib/utils";
import type { IconProps } from "@/types";

interface LogoProps extends IconProps {
  /** Gradient mark only (`/images/Kriya_2.svg`), no wordmark text. */
  variant?: "wordmark" | "mark";
}

const wordmarkImgClass =
  "h-full max-h-full w-auto max-w-full object-contain object-center";

const MARK_SRC = "/images/Kriya_2.svg";

/**
 * Official Kriyastream branding from `/public/images/`.
 * Wordmark: `logos/kriyastream-logo-*-sm.svg` (`dark-*` on light UI, `light-*` on dark).
 * Mark: `Kriya_2.svg` (icon only).
 */
const Logo = ({
  className,
  variant = "wordmark",
}: LogoProps): JSX.Element => {
  if (variant === "mark") {
    return (
      <span
        className={cn(
          "inline-flex size-8 shrink-0 items-center justify-center",
          className,
        )}
        role="img"
        aria-label="Kriyastream"
      >
        <img
          src={MARK_SRC}
          alt=""
          width={128}
          height={128}
          className="size-full object-contain"
          decoding="async"
          fetchPriority="low"
        />
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden",
        "h-6 w-auto max-h-6",
        className,
      )}
      role="img"
      aria-label="Kriyastream"
    >
      <img
        src="/images/logos/kriyastream-logo-dark-sm.svg"
        alt=""
        width={199}
        height={36}
        className={cn(wordmarkImgClass, "dark:hidden")}
        decoding="async"
        fetchPriority="low"
      />
      <img
        src="/images/logos/kriyastream-logo-light-sm.svg"
        alt=""
        width={199}
        height={36}
        className={cn(wordmarkImgClass, "hidden dark:block")}
        decoding="async"
        fetchPriority="low"
      />
    </span>
  );
};

export default Logo;
